<script setup lang="ts">
const { locale, locales, setLocale } = useI18n();

const flagByCode: Record<string, string> = {
  ru: 'cif-ru',
  en: 'cif-gb',
  pl: 'cif-pl',
  lt: 'cif-lt'
};

const availableLocales = computed(() => (typeof locales.value[0] === 'string'
  ? []
  : (locales.value as { code: string, name?: string }[])));

</script>

<template>
  <div class="d-flex gap-2">
    <button
      v-for="loc in availableLocales"
      :key="loc.code"
      type="button"
      class="btn btn-sm p-1 lh-1"
      :class="loc.code === locale ? 'btn-outline-primary' : 'btn-outline-secondary border-0'"
      @click="setLocale(loc.code as typeof locale)"
    >
      <i
        class="icon"
        :class="flagByCode[loc.code] ?? 'cil-globe'"
      />
    </button>
  </div>
</template>
